module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_photogenicjorney-07adfe9f8b13725f708eed569e0e5632.svg";